import styled from "styled-components";

interface ITooltipItem {
  isRead?: boolean;
};

export const Indicators = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  width: 95%;
  gap: 6px;
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const IconIndicators = styled.img``;

export const TooltipIndicator = styled.span<ITooltipItem>`
  visibility: hidden;
  background-color: #ffffff;
  color: #364863;
  min-width: 120px;
  border: 1px solid #f2f3f4;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1000000;
  left: ${(props) => (props.isRead ? "70%" : "-180%")};
  bottom: 90%;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.4px;
  transform: ${(props) =>
    props.isRead ? "translateX(-100%)" : "translateX(-50%)"};

  ${TooltipContainer}:hover & {
    visibility: visible;
  }
`;
